import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { User, mapUserToFormData, UserForm } from "../UserManagement/User";
import {
  useTreeData,
  UnsavedChangesPrompt,
} from "@velocity-ehs/component-library";
import UsersService from "@velocity-ehs/user-utils-module";
import { PrimaryLocation } from "./cards/PrimaryLocation";
import { EmploymentDetails } from "./cards/EmploymentDetails";
import { PersonalDetails } from "./cards/PersonalDetails";
import { useHistory } from "react-router-dom";

interface Props {
  profile?: User;
  isLoading?: boolean;
  onSave: (values: any) => void;
}

const ModifyProfileForm: React.FC<Props> = ({ profile, isLoading, onSave }) => {
  const treeData = useTreeData();

  const history = useHistory();

  const formMethods = useForm<UserForm>({
    mode: "onBlur",
  });

  useEffect(() => {
    if (treeData.isAllFetched && profile?.id) {
      formMethods.reset(
        mapUserToFormData(
          { ...profile, ...profile.person?.personSensitive },
          treeData
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.id, treeData.isAllFetched]);

  const isDirty = Object.keys(formMethods.formState.dirtyFields).length > 0;

  const handleSubmit = (values: UserForm) => {
    formMethods.reset(values);
    onSave(values);
  };

  return (
    <>
      <form
        id="modify-profile-form"
        onSubmit={formMethods.handleSubmit(handleSubmit)}
      >
        <PersonalDetails
          formMethods={formMethods}
          isLoading={isLoading || !treeData.isAllFetched}
          isReadOnly={!UsersService.permissions.canEditPersons}
        />
        <PrimaryLocation
          formMethods={formMethods}
          isLoading={isLoading || !treeData.isAllFetched}
          isReadOnly={!UsersService.permissions.canEditPersons}
          currentLocation={profile.person?.primaryLocation}
        />
        <EmploymentDetails
          formMethods={formMethods}
          isLoading={isLoading || !treeData.isAllFetched}
          isReadOnly={!UsersService.permissions.canEditSensitiveData}
        />
        <UnsavedChangesPrompt isDirty={isDirty} history={history} />
      </form>
    </>
  );
};

export default ModifyProfileForm;
